import React, { useState } from "react";
import TemplateBase from "../Generico/TemplateBase";
import { Box } from "@mui/material";
import CardQuick from "./components/CardQuick/index.js";
import Chart from "./components/Chart";
import "./assets/css/material-dashboard-react.css";
import Divider from "@mui/material/Divider";
import ListDashboard from "./components/List/Index";
import DashboardFilter from "./components/DashboardFilter";
import { subHours, addDays, format } from "date-fns";

const Dashboard = () => {
  const [tipoPedido, setTipoPedido] = useState("TODOS");
  const [periodo, setPeriodo] = useState({
    dataInicial: `${format(subHours(new Date(), 6), "yyyy-MM-dd")} 06:00:00`,
    dataFinal: `${format(
      addDays(subHours(new Date(), 6), 1),
      "yyyy-MM-dd"
    )} 06:00:00`,
  });

  const handleSetPeriodo = (newPeriodo) => {
    setPeriodo(newPeriodo);
  };
  return (
    <TemplateBase
      title="Dashboard"
      subTitle="Acompanhe o resultado das suas vendas."
      component={true}
    >
      <Box padding="2rem">
        <DashboardFilter
          periodo={periodo}
          tipoPedido={tipoPedido}
          setTipoPedido={setTipoPedido}
          setPeriodo={handleSetPeriodo}
        />

        <Box padding="2rem">
          <Divider variant="middle" />
        </Box>

        <CardQuick periodo={periodo} tipoPedido={tipoPedido} />
        <Chart periodo={periodo} tipoPedido={tipoPedido} />
        <ListDashboard periodo={periodo} tipoPedido={tipoPedido} />
      </Box>
    </TemplateBase>
  );
};

export default Dashboard;
